import { Field, Float, ID, Int, ObjectType } from 'type-graphql'
import { Prop, PropType } from '@typegoose/typegoose'
import { Contact, generateEntityId } from '@ztechapps/common.contract'
import { SyncInfo } from './SyncInfo'
import { HaulerLogo } from './HaulerLogo'
import { HaulerPlant } from '@ztechapps/totalmilk-tmms.common'
import { HaulerCustomerUnitId } from './HaulerCustomerUnitId'
import { MilkPickupDriverRef } from './MilkPickupDriverRef'

@ObjectType()
export class MilkPickupDetailCustomer {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => SyncInfo, { nullable: true })
  @Prop({ type: SyncInfo })
  _syncInfo?: ReturnType<() => SyncInfo>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  plantCode?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  name?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  code?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  summary?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  type?: string

  @Field(() => HaulerLogo, { nullable: true })
  @Prop({ type: HaulerLogo })
  logo?: ReturnType<() => HaulerLogo>

  @Field(() => Contact, { nullable: true })
  @Prop({ type: Contact })
  contact?: ReturnType<() => Contact>

  @Field(() => HaulerPlant, { nullable: true })
  @Prop({ type: HaulerPlant })
  plant?: ReturnType<() => HaulerPlant>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  reportId?: string

  @Field(() => [HaulerCustomerUnitId], { nullable: true })
  @Prop({ type: [HaulerCustomerUnitId] }, PropType.ARRAY)
  unitIds?: ReturnType<() => HaulerCustomerUnitId[]>
}

@ObjectType()
export class MilkPickupDetail {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('mpkpdtl') })
  _id: string

  @Field(() => MilkPickupDetailCustomer, { nullable: true })
  @Prop({ type: MilkPickupDetailCustomer })
  customer?: ReturnType<() => MilkPickupDetailCustomer>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  code?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  gradeType?: string

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  weight?: number

  @Field(() => Date, { nullable: true })
  @Prop({ type: Date })
  timeStamp?: Date

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  gaugeRod?: string

  @Field(() => Int, { nullable: true })
  @Prop({ type: Number })
  temperature?: number

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  remarks?: string

  @Field(() => Int, { nullable: true })
  @Prop({ type: Number })
  numberOfMilkings?: number

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  cpd?: string

  @Field(() => MilkPickupDriverRef, { nullable: true })
  @Prop({ type: MilkPickupDriverRef })
  driver?: ReturnType<() => MilkPickupDriverRef>

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  unitId?: string

  @Field(() => [String], { nullable: true })
  @Prop({ type: [String] })
  gradeTypeTags?: string[]
}
